import script from "./TestMediaUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./TestMediaUploader.vue?vue&type=script&setup=true&lang=js"

import "./TestMediaUploader.vue?vue&type=style&index=0&id=1ac00c15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac00c15"]])

export default __exports__